import React from 'react';

function SystemStats({ stats }) {
  const formatBytes = (bytes) => {
    if (!bytes) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
  };

  return (
    <div className="dashboard-card third-width">
      <h2>System Stats</h2>
      <div className="system-stats-grid">
        <div className="stat-item">
          <span className="stat-label">CPU Usage</span>
          <span className="stat-value">{stats.cpu_percent || 0}%</span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Memory Usage</span>
          <span className="stat-value">{stats.memory_percent || 0}%</span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Bot CPU</span>
          <span className="stat-value">{stats.bot_cpu || 0}%</span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Bot Memory</span>
          <span className="stat-value">{formatBytes(stats.bot_memory)}</span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Disk Usage</span>
          <span className="stat-value">{stats.disk_percent || 0}%</span>
        </div>
        <div className="stat-item">
          <span className="stat-label">Free Memory</span>
          <span className="stat-value">
            {formatBytes(stats.memory_total - stats.memory_used)}
          </span>
        </div>
      </div>
    </div>
  );
}

export default SystemStats;